export default {
  view: {
    back: {
      title1: 'Транзакцію прийнято в реалізацію!',
      title2: 'Дякуємо, що ви з нами!',
      buttonTopup: 'Поповнити ще раз',
      buttonBack: 'Далі'
    },
    backCreditCard: {
      title1: 'Вашу платіжну картку перевірено!',
      title1a: 'Повторний платіж BLIK увімкнено',
      title2: 'Подальші платежі поповнення будуть збиратися автоматично.',
      titleVerify: 'Обробка платежу',
      titleError: 'Не вдалося обробити платіж!',
      buttonBack: 'Далі',
      blikDescription: 'Підтвердьте та створіть регулярний платіж у програмі свого банку.'
    },
    contacts: {
      header: 'Контакти'
    },
    unregister: {
      loading: 'Зачекайте. Декларація перевіряється...',
      title1ok: 'Дякуємо за повідомлення.',
      title2ok: 'Ваш контакт був видалений. Ви не будете отримувати такі повідомлення. З найкращими побажаннями!',
      title1error: 'Упс... Щось пішло не так.',
      title2error: 'Спробуйте ще раз видалити підписку.',
      buttonTopup: 'Поповнити рахунок телефону'
    },
    userTerms: {
      loading: 'Триває обробка даних...',
      header: 'Прийміть правила облікового запису',
      fieldTermsAgree: 'Я ознайомився і приймаю <a href="/files/plus/Regulamin-prowadzenia-konta-PLUS_en.pdf" target="_blank">Правила</a> ведення облікового запису на сайті doladuj.plus.pl і <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank" rel="noreferrer">Політику конфіденційності</a>',
      required: 'Обовязкове поле',
      rodoText: 'Адміністратором персональних даних є Autopay S.A. ul. вул. Powstańców Warszawy 6, 81-718 Sopot. Надання персональних даних є добровільним, але необхідним для завершення платежу. Правова основа, мета, термін обробки персональних даних та права Користувача, а також інша важлива інформація щодо правил обробки персональних даних детально описані на сайті <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank" rel="noreferrer">Політика конфіденційності Autopay S.A.</a>',
      buttonNext: 'Далі',
      messges: {
        setTermsSuccess: 'Згоду з регламентом збережено правильно!',
        setTermsError: 'Під час спроби зберегти згоду з умовами сталася помилка!'
      }
    },
    history: {
      header: 'Історія поповнення'
    },
    userData: {
      header: 'Мої дані'
    }
  },
  component: {
    cookie: {
      text: 'Я погоджуюся зберігати файли cookie на своєму пристрої.',
      button: 'OK'
    },
    header: {
      linkLogin: 'Увійти',
      title: 'Поповнення он-лайн Плюс',
      loading: 'Завантаження даних...',
      linkTopup: 'Поповнити',
      linkHistory: 'Історія',
      linkContacts: 'Контакти',
      linkMyData: 'Мої дані',
      linkLogout: 'Вихід із системи',
      a11y: {
        skipButton: 'Перехід до основного вмісту',
        hamburgerButton: 'Показати навігаційний режим',
        closeButton: 'Приховати навігаційний режим',
        languages: {
          pl: 'Змінити мову на польську',
          en: 'Змінити мову на англійську',
          uk: 'Змінити мову на українську'
        },
        nav: {
          main: 'Перейти на головну сторінку',
          linkTopup: 'Перейти на сторінку поповнення',
          linkHistory: 'Перейти на сторінку історії поповнення',
          linkContacts: 'Перейти на сторінку контактів',
          linkMyData: 'Перейти на сторінку Мої дані',
          linkLogout: 'Вийти з системи'
        }
      }
    },
    autotopup: {
      progress: {
        step1: 'Тип поповнення',
        step2: 'Номер телефону',
        step3: 'Активація'
      },
      start: {
        header: 'Виберіть тип поповнення',
        topupSingle: 'Одноразове поповнення',
        topupAuto: 'Регулярно повторювані поповнення',
        errorTypeRequired: 'Виберіть тип поповнення',
        buttonNext: 'Далі',
        a11y: {
          nav: {
            topupTypeSingle: 'Перейти на сторінку з формою одноразового поповнення',
            topupTypeAuto: 'Перейти на сторінку з формою періодичного поповнення'
          }
        }
      },
      stage1: {
        title: '<strong>Крок 1</strong> - тип поповнення',
        header: 'Виберіть умови поповнення',
        errorTypeRequired: 'Виберіть умову поповнення',
        periodLabel: 'Вкажіть інтервал поповнення (у днях)',
        dayLabel: 'День поповнення',
        buttonNext: 'Далі',
        fieldAmountLabel1: 'Поповнити рахунок сумою',
        fieldAmountLabel2: 'PLN',
        fieldPeriodLabel1: 'кожні',
        fieldPeriodLabel2: 'дні (-в), починаючи з',
        fieldPeriodPlaceholder: 'дата поповнення',
        fieldTopupDayLabel1: 'кожного',
        fieldTopupDayLabel2: 'дня місяця',
        errorAmountRequired: 'Вкажіть суму поповнення',
        errorPeriodRequired: 'Вкажіть період, протягом якого має відбуватися поповнення',
        errorNextTopupDayRequired: 'Вкажіть дату поповнення',
        a11y: {
          toNextStepButton: 'Перейти до другого кроку в новому поданні'
        }
      },
      stage2: {
        title: '<strong>Крок 2</strong> - номер телефону',
        headerNoContacts: 'Додайте номер для поповнення',
        header1: 'Виберіть номер зі списку',
        header2: 'Або додайте номер для поповнення',
        contactCheckphoneError: 'Наразі номер телефону не можна поповнити!',
        labelPhone: 'Номер телефону, який Ви хочете поповнити',
        errorPhoneRequired: 'Необхідно вказати номер телефону',
        errorPhoneInvalid: 'Неправильний номер телефону',
        errorPhoneCheck: 'Номер телефону не може бути поповнений',
        errorPhoneAutotopupActive: 'Цей номер телефону  регулярно  поповнюється',
        labelName: 'Назва контактної особи',
        fieldNamePlaceholder: 'Назва контактної особи',
        errorNameRequired: 'Необхідно вказати назву контактної особи',
        buttonNext: 'Далі',
        buttonBack: 'Назад',
        a11y: {
          toPreviousStepButton: 'Перейти до першого кроку в новому поданні',
          toNextStepButton: 'Перейти до третього кроку в новому поданні'
        }
      },
      stage4: {
        title: '<strong>Крок 3</strong> - активація поповнення',
        header: 'Підведення підсумку',
        creditCardInfo: 'Через мить ми попросимо вас додати картку, з якої ми будемо періодично знімати вибрану вами суму. Підготуйте всі необхідні дані: номер картки, термін дії картки та CVV/CVC код.',
        blikInfo: 'За мить ми попросимо вас активувати регулярний платіж BLIK. Згенеруйте 6-значний BLIK-код у своїй банківській програмі.',
        summaryHeader: 'Перевірте правильність наступних даних.',
        topupInfoLabel: 'Інформація про поповнення',
        topupInfoType1Label: 'Тип поповнення',
        topupInfoType1Text: 'Циклічне поповнення',
        topupInfoType2Label: 'Правило поповнення',
        topupInfoType2Text: 'На основі дати',
        topupInfoAmountLabel: 'Сума поповнення',
        topupInfoDayLabel: 'День поповнення',
        topupInfoPeriodLabel: 'Період поповнення',
        topupInfoPeriodText: 'кожні {день} днів',
        topupInfoNextDateLabel: 'Дата поповнення',
        topupContactLabel: 'Контактна інформація',
        topupContactPhoneLabel: 'Номер телефону',
        topupContactNameLabel: 'Ім\'я',
        agreementErrorHeader: 'Помилка завантаження умов використання',
        agreementErrorMessage: 'Вибачте, але з технічних причин не вдалося завантажити Правил послуги. Спробуйте ще раз через деякий час.',
        agreementText: '<span class="red">*</span> Я прочитав і приймаю <a href="{regulationUrl}" target="_blank">Правила автоматичного поповнення телефону</a> та <a href= "https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer">Політика конфіденційності</a>.',
        paymentText: '<span class="red">*</span> Я хочу, щоб послуга була виконана негайно, і я визнаю, що якщо послугу буде виконано повністю, я втрачу право відмовитися від контракту після її завершення.',
        termsText: '<span class="red">*</span> Я погоджуюся на циклічне виставлення рахунків Autopay S.A. моєї платіжної картки на фіксовані суми, що випливають з вибраного номіналу поповнення телефону, відповідно до <a href="{regulationUrl}" target="_blank">Положення про автоматичне поповнення телефону</a>. Платіжна картка буде стягуватися з періодичністю, обраною мною на сайті Поповнення он-лайн Плюс, доки я не скасую циклічне списання картки. Я підтверджую, що маю право відмовитися від циклічного стягнення плати з моєї платіжної картки у спосіб, визначений у <a href="{regulationUrl}" target="_blank">Положеннях про автоматичне поповнення рахунку телефону</a>. У разі будь-яких питань, пов’язаних із автоматичним поповненням, звертайтеся до відділу обслуговування клієнтів Autopay S.A. у спосіб, указаний у <a href="{regulationUrl}" target="_blank">Правилах автоматичного поповнення телефону</a>.',
        required: 'обов\'язкове поле',
        buttonNext: 'Далі',
        buttonBack: 'Назад',
        paymentMethodCard: 'Платіжна картка',
        paymentMethodBlik: 'Регулярні платежі BLIK',
        messges: {
          addTopupErrorHeader: 'Помилка!',
          addTopupError: 'Не вдалося записати регулярно повторюваного поповнення!',
          addTopupSuccess: 'Регулярно повторюване поповнення записано!'
        },
        a11y: {
          toPreviousStepButton: 'Перейти до другого кроку в новому режимі перегляду',
          submitButton: 'Перейти на нову сторінку оплати'
        }
      }
    },
    blik: {
      header: 'Регулярні платежі BLIK',
      loadingText: 'Завантаження даних...',
      verifyText1: 'Щоб активувати регулярні платежі BLIK, введіть 6-значний код BLIK із програми свого банку.',
      verifyText2: 'Тепер ви заплатите 1 злотий, щоб ми могли ввімкнути регулярні платежі BLIK. Пізніше ми повернемо вам цю суму.',
      descriptionText: 'Для виконання цього замовлення нам потрібні ваші дані. Натиснувши «Оплатити», ви вирішуєте переказати його нам. Адміністратором ваших персональних даних є Autopay з юридичною адресою в м. Сопот, вул. Powstańców Warszawy 6, 81-718. Інформацію про правову основу, мету та період, протягом якого ми зберігатимемо ваші дані, а також права, якими ви (як користувач) маєте право, можна знайти на <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Політика конфіденційності Autopay S.A.</a>',
      blikDescription: 'Ви активуєте BLIK регулярні платежі для свого облікового запису. Ви можете оплачувати регулярні поповнення за допомогою цього способу оплати. Ви самостійно встановлюєте розмір і частоту стягнення комісій за регулярні поповнення. Ви можете ввімкнути їх для будь-якого номера телефону, який ви зберегли на сайті - зараз чи в майбутньому. Ви можете активувати регулярні платежі BLIK в таких банках:',
      labelBlik: 'Введіть код BLIK',
      placeholderBlik: 'BLIK код',
      buttonNext: 'платити',
      errorFieldRequired: 'Обов\'язкове поле',
      errorFieldPattern: 'Код BLIK має складатися з 6 цифр',
      errorBankNotSupported: 'Ви не можете розпочати регулярні платежі BLIK, оскільки ця послуга не підтримується вашим банком. Перевірте список доступних банків.',
      summary: {
        nameLabel: 'Ім\'я',
        nameValue: 'періодичний платіж',
        amountLabel: 'Сума поповнення',
        amountValue: 'будь-який',
        frequencyLabel: 'Частота',
        frequencyValue: 'будь-який',
        payLabel: 'Зараз ти заплатиш',
        payValue: '1 злотий'
      },
      messges: {
        addTokenSuccessHeader: 'Успіх!',
        addTokenSuccess: 'Ваш регулярний платіж BLIK обробляється. Незабаром це буде видно в розділі Мої дані.',
        addTokenErrorHeader: 'помилка!',
        addTokenError: 'Не вдалося зберегти BLIK!'
      }
    },
    creditcard: {
      header: 'Платіжна картка',
      loadingText: 'Завантаження даних...',
      verifyText: 'Для перевірки картки ми знімемо з Вашого рахунку 1 PLN і повернемо його коли перевірка пройде успішно',
      iframeValidationError: 'Вказано неправильні дані',
      iframeValidationSuccess: 'Вказано правильні дані',
      descriptionText: 'Щоб виконати це замовлення, нам потрібні Ваші дані. Вибираючи "Оплатити", Ви погоджуєтесь передати їх нам. Адміністратором Ваших персональних даних є Autopay, з місцезнаходженням за адресою: 81-718  Sopot ul. Powstańców Warszawy 6, [81-718 Сопот, вул. Повстанців Варшави 6]. Інформацію про  юридичну підставу,  мету і період, протягом якого ми будемо зберігати Ваші дані, а також про Ваші (Користувача) права, Ви знайдете в <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank">Політика конфіденційності Autopay S. A.</a>',
      buttonNext: 'Оплатити',
      messges: {
        addTokenErrorHeader: 'Помилка!',
        addTokenError: 'Не вдалося записати дані картки!'
      }
    },
    progress: {
      step1: 'Номер телефону і <span>e-mail</span>',
      step2: 'Сума поповнення',
      step3: 'Підсумок платіж'
    },
    stage1: {
      formErrorHeader: 'Виправити помилки у формі',
      formErrorPhone: 'Вказати хоча б один номер телефону для поповнення.',
      formErrorEmail: 'Вказати правильну адресу електронної пошти.',
      formErrorCheckphone: 'Номер {phone} не може бути поповнений.',
      title: '<strong>Крок 1</strong> - Номер телефону та електронна пошта',
      header: 'Вказати номер телефону та адресу електронної пошти',
      labelPhone: 'Номер телефону, який ви хочете поповнити',
      errorPhoneRequired: 'Вимагається номер телефону',
      errorPhoneInvalid: 'Неправильно вказаний номер телефону',
      errorPhoneCheck: 'Номер телефону не може бути поповнений',
      labelEmail: 'Адреса електронної пошти',
      placeholderEmail: 'Вказати адресу електронної пошти',
      errorEmailRequired: 'Вимагається адреса електронної пошти',
      errorEmailInvalid: 'Неправильно вказана адреса електронної пошти',
      emailDescription: 'На цю адресу електронної пошти буде надіслано підтвердження поповнення.',
      addPhone: 'Додати ще один номер',
      addPhoneMaxInfo: '(max. {count} номерів)',
      required: `поля, обов'язкові до заповнення`,
      buttonNext: 'Далі',
      maintenanceHeader1: 'Триває технічна перерва.',
      maintenanceHeader2: 'Запрошуємо 28.05.2020 з 08:00.',
      headerLogged1: 'Вибрати номер зі списку',
      headerLogged2: 'або ввести номер для поповнення',
      loadingText: 'Завантаження даних...',
      contactCheckphoneError: 'Наразі номер телефону не можна поповнити!',
      a11y: {
        addNumberButton: 'Показати наступне поле для введення номера телефону',
        removeNumberButton: 'Видалити поле номера телефону',
        chooseNumberButton: 'Виберіть цей номер телефону',
        unselectNumberButton: 'Скасувати вибір цього номера телефону'
      }
    },
    stage2: {
      title: '<strong>Крок 2</strong> - Сума поповнення',
      header: 'Сума поповнення для номеру <span>{phone}</span>',
      headerLogged: 'Сума поповнення для <span>{contactName}</span>',
      advTitle: 'Отримати додаткове поповнення!',
      advText: 'Поповніть свій рахунок 4 рази на будь-яку суму, і ви отримаєте додаткові бонусні гроші',
      advLink: 'Умови акції',
      recommend: 'Рекомендується!',
      otherAmount: 'інша<br>сума',
      messageAmountMin: 'Вказана сума була змінена, тому що мінімальна сума поповнення <strong>{amount} PLN</strong>.',
      messageAmountMax: 'Вказана сума була змінена, тому що максимальна сума поповнення <strong>{amount} PLN</strong>.',
      buttonBack: 'Назад',
      buttonNext: 'Далі',
      saveContact: 'Додати в книгу одержувачів',
      setReminder: 'Нагадати про поповнення',
      setReminderIn: 'за',
      setReminderDays: 'дні',
      placeholderContactName: 'Контактна Особа',
      a11y: {
        advLink: 'Перейти до PDF-документа з Правилами поповнення рахунку'
      }
    },
    stage3: {
      title: '<strong>Крок 3</strong > - Підсумок та оплата',
      header: 'Підсумок',
      loadingText: 'Обробка даних...',
      topupErrorHeader: 'Сталася помилка при обробці поповнення!',
      topuperrortext: 'Спробувати ще раз або звернутися до служби підтримки.',
      labelPhone: 'Номер телефону',
      labelAmount: 'Сума',
      labelEmail: 'Адреса електронної пошти',
      checkAll: 'Вибрати всі дозволи',
      agreementText: '<span class="red">*</span> Я ознайомився і приймаю <a href="/files/plus/Regulamin-doladowan-PLUS_en.pdf" target="_blank" rel="noreferrer" title="Перейти на сторінку з PDF-документом PLUS Правила поповнення рахунку">Правила поповнення мобільних телефонів</a> i <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank" rel="noreferrer" title="Перейти на сторінку з PDF-документом Політика конфіденційності">Політику конфіденційності</a>',
      paymentText: '<span class="red">*</span> Я хочу негайного надання послуги, і приймаю до відома, що у випадку повного надання послуги, з моментом її надання, я втрачаю будь-яке право відмовитися від договору.',
      marketingText: 'Хочу отримувати від Autopay S. A. або її партнерів по електронній пошті або по телефону інформацію про акції, конкурси та інші цікаві заходи, організовані Autopay. Я знаю, що Autopay не спамить мене непотрібною інформацією, і що я можу відкликати свою згоду в будь-який час.',
      rodoText: 'Адміністратором персональних даних є Autopay S. A. Powstańców Warszawy 6, 81-718 Sopot. Надання персональних даних є добровільним, але необхідним для здійснення платежу. Правова основа, мета, термін обробки персональних даних, права Користувача, а також інша важлива інформація про політику обробки персональних даних детально викладена в <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank" rel="noreferrer" title="Перейти на сторінку з PDF-документом Політика конфіденційності">Політиці конфіденційності Autopay S.A.</a>',
      buttonBack: 'Назад',
      buttonNext: 'Замовляю і оплачую',
      required: `Поле, обов'язкове до заповнення`
    },
    footer: {
      linkTerms: 'Правила послуги',
      linkTermsPromo1: 'Правила акції"4 поповнення безкоштовно"',
      linkTermsAuto: 'Правила регулярних поповнювань',
      linkInvoice: 'Рахунок за поповнення',
      linkFaq: 'Часті питання',
      registerSim: 'Зареєструвати SIM-карту',
      copyrights: '© {year} Polkomtel Sp. z o.o. Усі права захищені',
      menu: {
        linkAboutUs: 'Про компанію',
        linkContact: 'Контакт',
        linkPress: 'Прес-служба',
        linkNews: 'Повідомлення',
        linkJob: 'Робота',
        linkPrivacyPolicy: 'Політика конфіденційності',
        linkSiteMap: 'Карта сайту'
      }
    },
    contacts: {
      loadingText: 'Завантаження даних...',
      addContact: 'Додати контакт',
      form: {
        labelName: `Назва/Ім’я`,
        errorName: 'Вимагається назва /ім’я контакту',
        labelPhone: 'Номер телефону',
        errorPhoneRequired: 'Вимагається номер телефону',
        errorPhoneInvalid: 'Неправильно вказаний номер телефону',
        errorPhoneCheck: 'Номер телефону не може бути поповнений',
        errorPhoneNotUnique: 'Номер телефону вже є в Контактах',
        tooltipButtonSave: 'Зберегти',
        tooltipButtonCancel: 'Скасувати'
      },
      list: {
        emptyText: 'Немає даних',
        labelName: 'Назва',
        labelPhone: 'Номер телефону',
        labelAutotopup: 'Циклічне поповнення',
        labelPaymentMethod: 'Джерело платежу',
        paymentMethodBlik: 'BLIK',
        paymentMethodCard: 'Платіжна картка',
        tooltipButtonEdit: 'Редагування',
        tooltipButtonDelete: 'Видаліть',
        tooltipButtonTopup: 'Поповніть',
        topupPeriodConditions: '{amount} PLN кожні {day} днів',
        topupPeriodNextDate: 'Дата поповнення:',
        topupDayConditions: '{amount} PLN {day} числа місяця',
        topupButtonAdd: 'Клацніть, щоб додати',
        a11y: {
          topupButtonAdd: 'Перейти на сторінку налаштувань поповнення',
          topupButton: 'Перейти на сторінку поповнення',
          topupButtonEdit: 'Відкрити вікно редагування контакту'
        }
      },
      messges: {
        removeHeader: 'Увага!',
        removeConfirm: 'Чи напевно видалити контакт?',
        removeConfirmButton: 'Видалити',
        removeCancelButton: 'Скасувати',
        removeSuccess: 'Контакт був видалений!',
        removeError: 'Не вдалося видалити контакт.',
        phoneVerifyHeader: 'Помилка!',
        phoneVerifyError: 'При перевірці номера телефону сталася помилка.',
        addContactSuccess: 'Контакт був доданий.',
        addContactErrorHeader: 'Помилка!',
        addContactError: 'Не вдалося додати контакт.',
        updateContactSuccess: 'Контакт був оновлений.',
        updateContactErrorHeader: 'Помилка!',
        updateContactError: 'Не вдалося оновити контакт.'
      }
    },
    contactsEdit: {
      header: 'Редагування контакту',
      buttonBack: 'Скасувати',
      buttonNext: 'Зберегти',
      buttonPaymentTypeBlik: 'BLIK',
      buttonPaymentTypeCard: 'Платіжна картка',
      autotopupHeader: 'Циклічне поповнення',
      paymentMethodHeader: 'Тип оплати',
      contactButtonDelete: 'Видалити контакт',
      autotopupButtonDelete: 'Видалити регулярно повторюване поповнення',
      autotopupButtonAdd: 'Додавання регулярно поповнюється',
      messges: {
        updateAutotopupSuccess: 'Ваше регулярно повторюване поповнення оновлено!',
        updateAutotopupError: 'Не вдалося актуалізувати дані регулярно повторюваного поповнення!',
        removeHeader: 'Увага!',
        removeConfirm: 'Ви впевнені, що хочете видалити регулярно повторюване поповнення?',
        removeConfirmButton: 'Видалити',
        removeCancelButton: 'Скасувати',
        removeSuccess: 'Ваше регулярно повторюване поповнення було видалено!',
        removeError: 'Не вдалося видалити регулярно повторюване поповнення.',
        updateContactSuccess: 'Контакт оновлено!',
        updateContactError: 'Контактні дані не вдалось оновити!'
      },
      a11y: {
        autotopupButtonAdd: 'Перейти на сторінку налаштування поповнення',
        buttonBack: 'Скасувати зміни та перейти на сторінку контактів',
        buttonNext: 'Зберегти зміни та перейти на сторінку контактів',
        buttonPaymentTypeCard: 'Виберіть платіжну картку як тип оплати',
        buttonPaymentTypeBlik: 'Виберіть Blik як тип оплати'
      }
    },
    history: {
      filter: {
        labelDateStart: 'Дата початку',
        labelDateEnd: ' Дата закінчення',
        errorDateStart: 'Ввести правильну дату початку',
        errorDateEnd: 'Ввести правильну дату закінчення',
        buttonSearch: 'Пошук'
      },
      list: {
        emptyText: 'Відсутність даних в історії поповнення',
        labelPaymentDate: 'Дата',
        labelTopupAmount: 'Сума',
        labelTopupType: 'Тип',
        labelPhoneNumber: 'Телефон',
        labelPaymentId: 'ID',
        labelPaymentStatus: 'Статус',
        labelTopupStatus: 'Поповнення',
        paymentStatusOk: 'оплачено',
        paymentStatusWait: 'очікує',
        paymentStatusError: 'помилка оплати',
        topupStatusOk: 'зроблено',
        topupStatusWait: 'чекає',
        topupStatusError: 'помилка перезарядки',
        tooltipTopupAgain: 'Поповнити ще раз',
        tooltipTopupSingle: 'Одноразове поповнення',
        tooltipTopupAuto: 'Регулярно повторювані поповнення',
        a11y: {
          pageSizeSelect: 'Змінити кількість відображених записів',
          topupButton: 'Перейти на сторінку поповнення'
        }
      }
    },
    userData: {
      account: {
        header: 'Обліковий запис Користувача',
        labelEmail: 'Електронна пошта:',
        labelPassword: 'Пароль:',
        buttonRemoveAccount: 'Видалити',
        messages: {
          removeHeader: 'Увага!',
          removeConfirm: 'Ви впевнені, що хочете видалити свій обліковий запис?',
          removeConfirmButton: 'Видалити',
          removeCancelButton: 'Скасувати',
          removeSuccess: 'Ваш обліковий запис було видалено.',
          removeError: 'Не вдалося видалити обліковий запис!'
        },
        a11y: {
          buttonEditAccount: 'Перейти до режиму редагування даних користувача'
        }
      },
      payment: {
        header: 'Повторювані способи оплати',
        description: 'Додайте спосіб оплати для оплати регулярних поповнень. Ви можете будь-коли видалити способи оплати або змінити спосіб оплати регулярних поповнень для окремих номерів телефону. Якщо у вас немає активного способу оплати, послуга періодичного поповнення вимкнена.',
        labelStatus: 'Статус:',
        labelType: 'Тип:',
        labelCardNumber: 'Номер картки',
        labelCardValidity: 'Термін дії:',
        creditCardType: 'Платіжна картка',
        blikType: 'Регулярні платежі BLIK',
        blikValidity: 'на невизначений термін',
        blikNumber: 'не застосовується',
        statusActive: 'АКТИВНА',
        statusInactive: 'НЕАКТИВНА',
        statusPending: 'ТРИВАЄ АКТИВАЦІЯ',
        statusFailure: 'ПОМИЛКА АКТИВАЦІЇ',
        buttonAddCreditCard: 'Додати платіжну картку',
        buttonAddBlik: 'Додайте платіж BLIK',
        buttonRemoveCreditCard: 'Видалити',
        buttonRemoveBlik: 'Видалити',
        messages: {
          removeHeader: 'Увага!',
          removeConfirm: 'Ви впевнені, що бажаєте видалити вибраний спосіб оплати? Без джерела платежу повторювані поповнення не можуть бути здійснені.',
          removeConfirmButton: 'Видалити',
          removeCancelButton: 'Скасувати',
          removeSuccess: 'Спосіб оплати видалено.',
          removeError: 'Не вдалося видалити спосіб оплати!'
        }
      }
    }
  },
  globalMessages: {
    userSessionTimeOut: 'З міркувань безпеки ви автоматично вийшли з системи. Увійдіть знову.'
  }
}
